// removed by extract-text-webpack-plugin
module.exports = {"voteCounter":"dh-stemning-voteCounter","voteCounter--theme-monsen":"dh-stemning-voteCounter--theme-monsen","voteCounter__count":"dh-stemning-voteCounter__count"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/widgets/LivePoll/components/LivePoll/VoteCounter/VoteCounter.css
// module id = 50
// module chunks = 0 1